import type { Metric } from 'web-vitals';

type ReportHandler = (metric: Metric) => void;

/**
 * web-vitals v4 переименовал API: getCLS/getFID/... -> onCLS/onINP/...
 * Старые имена не существуют, вызов падал бы в рантайме (и ломал tsc).
 */
const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (typeof onPerfEntry !== 'function') return;

  import('web-vitals').then(({ onCLS, onFCP, onINP, onLCP, onTTFB }) => {
    onCLS(onPerfEntry);
    onFCP(onPerfEntry);
    onINP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
  });
};

export default reportWebVitals;
